import { isDeepEqual } from '@attain-apps/data-utils'
import * as ents from '@attain-apps/entities'
import { TypeChecker } from '@attain-apps/type-guards'

import type { Plugin } from './plugin'

/**
 * Selectors for functional usage state
 */
export class Selectors {
  /** Computed selector indicating if in updating mode based on editingFunctionalUsage presence */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly isUpdating
  /** Functional usage for a space record */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly functionalUsage

  /** Functional usage being edited */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly editingFunctionalUsage

  /** Selector indicating if functional usage is being loaded from the backend */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly isLoading

  /** Selector indicating if there was an error while fetching a functional usage */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly error

  constructor(plugin: Plugin) {
    this.error = plugin.feature.state.project(state => state.error)
    this.functionalUsage = plugin.feature.state.project(
      state => state.functionalUsage,
    )
    this.editingFunctionalUsage = plugin.feature.state.project(
      state => state.editingFunctionalUsage,
    )
    this.isUpdating = plugin.feature.state.project(state =>
      TypeChecker.isNotNullish(state.editingFunctionalUsage),
    )
    this.isLoading = plugin.feature.state.project(state => state.isLoading)
  }
}
